export const navLinks = [
    { navLinkId: 'Home', scrollToId: 'home' },
    { navLinkId: 'About Me', scrollToId: 'aboutMe' },
    { navLinkId: 'Skills', scrollToId: 'skills' },
    { navLinkId: 'Experiences', scrollToId: 'experiences' },
    { navLinkId: 'Publications', scrollToId: 'publications' },
    { navLinkId: 'Contact', scrollToId: 'contact' }
];